<template>
  <div class="flex">
    <!-- Backdrop -->
    <div
        :class="[isSlidable ? '' : 'lg:hidden', isOpen ? 'block' : 'hidden']"
      @click="isOpen = false"
      class="fixed inset-0 z-20 transition-opacity bg-black opacity-50"
    ></div>
    <!-- End Backdrop -->

    <div
        :class="[isSlidable ? '' : 'lg:translate-x-0 lg:static lg:inset-0', isOpen ? 'translate-x-0 ease-out' : '-translate-x-full ease-in']"
        class="custom-scrollbar fixed inset-y-0 left-0 z-30 w-80 overflow-y-auto transition duration-300 transform bg-gray-900"
    >
      <div class="flex items-center justify-center mt-8">
        <div class="flex items-center text-white">
          <OfficeBuildingIcon class="w-12 h-12" />

          <span class="mx-2 text-2xl font-semibold">{{ $lang.app.APP_NAME }}</span>
        </div>
      </div>

      <nav class="mt-10">
        <SidebarItem v-for="(item, index) in items" :key="index" :item="item" />
      </nav>
    </div>
  </div>
</template>

<script>
import SidebarItem from "./../SidebarItem";

export default {
  components: {
    SidebarItem,
  },
  data() {
    return {
      isOpen: false,
      items: [
        {
          title: this.$lang.app.MANUAL,
          icon: "BookOpenIcon",
          type: "collapse",
          children: [
            {
              title: this.$lang.app.APPLICATION_STATUSES,
              icon: "StarIcon",
              type: "link",
              route: "AdminApplicationStatusesList",
            },
            {
              title: this.$lang.app.SECTIONS,
              icon: "CollectionIcon",
              type: "collapse",
              children: [
                {
                  title: this.$lang.app.TYPES,
                  icon: "LibraryIcon",
                  type: "link",
                  route: "AdminSectionTypesList",
                },
                {
                  title: this.$lang.app.DOCUMENTS,
                  icon: "LibraryIcon",
                  type: "link",
                  route: "AdminSectionDocumentsList",
                },
              ]
            },
            {
              title: this.$lang.app.CALCULATOR,
              icon: "CalculatorIcon",
              type: "collapse",
              children: [
                {
                  title: this.$lang.app.PURPOSE_OF_OBJECT,
                  icon: "OfficeBuildingIcon",
                  type: "link",
                  route: "AdminExpertPurposeCategoriesList",
                },
                {
                  title: this.$lang.app.PURPOSE_OF_OBJECT_TYPE,
                  icon: "OfficeBuildingIcon",
                  type: "link",
                  route: "AdminPurposeTypesList",
                },
              ]
            },
            {
              title: this.$lang.app.ADDITIONAL_EXPERTISE,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminAdditionalExpertisesList",
            },
            {
              title: this.$lang.app.APPOINTMENT,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminAppointmentsList",
            },
            {
              title: this.$lang.app.CONSTRUCTION_TYPE,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminConstructionTypesList",
            },
            {
              title: this.$lang.app.EXPERT_TYPE,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminExpertTypesList",
            },
            {
              title: this.$lang.app.CONTRACT_SUBJECT,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminContractSubjectsList",
            },
            {
              title: this.$lang.app.EXPERT_OBJECT,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminExpertObjectTypesList",
            },
            {
              title: this.$lang.app.LOCATION_CATEGORY,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminLocationCategoriesList",
            },
            {
              title: this.$lang.app.LOCATION_TYPE,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminLocationTypesList",
            },
            {
              title: this.$lang.app.PAYMENT_TYPE,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminPaymentTypesList",
            },
          ],
        },
        {
          title: this.$lang.app.ROUTES,
          icon: "TrendingUpIcon",
          type: "collapse",
          children: [
            {
              title: this.$lang.app.APPLICATIONS,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminApplicationRoutesList",
            },
            {
              title: this.$lang.app.RESOLUTIONS,
              icon: "DocumentDuplicateIcon",
              type: "link",
              route: "AdminResolutionRoutesList",
            },
          ]
        },
      ],
    };
  },
  computed: {
    isSlidable() {
      return this.$route.meta.sidebar === 'slidable'
    }
  },
  beforeMount() {
    this.$emitter.on("openSidebar", () => {
      this.isOpen = true;
    });
    this.$emitter.on("closeSidebar", () => {
      this.isOpen = false;
    });
  },
  beforeUnmount() {
    this.$emitter.off('openSidebar')
    this.$emitter.off('closeSidebar')
  }
};
</script>
